import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserData {
  user_id: string;
  email: string;
  first_name: string;
  last_name: string;
  uid: string;
  is_verified: boolean;
}

interface UserState {
  userData: UserData | null;
  loading: boolean;
  error: string | null;
}

const initialState: UserState = {
  userData: null,
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserData>) => {
      state.userData = action.payload;
      state.loading = false;
      state.error = null;
    },
    clearUser: (state) => {
      state.userData = null;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    fetchUserRequest: (state) => {
      state.loading = true;
    },
    fetchUserSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.userData = action.payload;
    },
    fetchUserFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { 
  setUser, 
  clearUser, 
  setLoading, 
  setError, 
  fetchUserRequest, 
  fetchUserSuccess, 
  fetchUserFailure 
} = userSlice.actions;
export default userSlice.reducer;
